import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser, setReturnURL } from '../../../utils/commonfunction';
import { ROLE, STAFF_ROLE } from "../../../utils/Constants";
import { useSelector } from 'react-redux';
import { selectRoutes, selectRole } from '../../../redux/slices/authSlice';
import NoPermission from '../common/noPermission';

const PrivateRoute = ({ component: Component, slug, superAdminOnly }) => {
    const userData = getUser(ROLE.SUPER_ADMIN);
    const routes = useSelector(selectRoutes);
    const role = useSelector(selectRole);

    const isLoggedIn = Object.keys(userData).length && userData.token;

    if (!isLoggedIn) {
        setReturnURL(ROLE.SUPER_ADMIN);
        return <Navigate to="/admin/login" />;
    }

    const isSuperAdmin = role === STAFF_ROLE.SUPER_ADMIN || userData?.role === STAFF_ROLE.SUPER_ADMIN;

    // Super-admin-only routes (e.g. sub-admin management)
    if (superAdminOnly && !isSuperAdmin) {
        return <NoPermission />;
    }

    // Slug-based permission check for sub-admins
    if (slug && !isSuperAdmin && !routes.includes(slug)) {
        return <NoPermission />;
    }

    return <Component />;
};

export default PrivateRoute;
